module.exports = __webpack_public_path__ + "static/Apache-b70b1f91fcb77d04f0d82e79fbdae634.svg";